/**
 * Feature Flags for MVP Launch
 * 
 * These flags control optional features that are not required for MVP.
 * When disabled, features fail gracefully without console errors.
 */

// AI Features Flag - Set to true when backend support is ready
export const AI_FEATURES_ENABLED = import.meta.env.VITE_AI_ENABLED === 'true' || false;

// Analytics Features Flag - Set to true when backend support is ready  
export const ANALYTICS_FEATURES_ENABLED = import.meta.env.VITE_ANALYTICS_ENABLED === 'true' || false;

/**
 * Safe console logging for non-critical features
 * - DEV: Uses console.warn for visibility
 * - PROD: Silent (no console output)
 */
export const safeLog = {
  warn: (message: string, ...args: any[]) => {
    if (import.meta.env.DEV) {
      console.warn(message, ...args);
    }
  },
  error: (message: string, ...args: any[]) => {
    if (import.meta.env.DEV) {
      console.warn(message, ...args); // Use warn instead of error for non-critical
    }
  }
};

/**
 * Legacy feature flags API (for compatibility with useFeatureFlag hook)
 * This is a stub implementation - returns false for all flags by default
 */
export const featureFlags = {
  load: async () => {
    // Stub - no-op for MVP
  },
  isEnabled: (key: string): boolean => {
    // For MVP, all dynamic feature flags are disabled
    // Use AI_FEATURES_ENABLED and ANALYTICS_FEATURES_ENABLED constants instead
    return false;
  }
};
